import React from 'react';
import { string, arrayOf, shape } from 'prop-types';
import { FormattedMessage } from '../../util/reactIntl';
import css from './SectionHowItWorks.module.css';

const SectionHowItWorks = props => {
  const { title, subtitle, steps } = props;

  // Default steps if none provided
  const defaultSteps = [
    {
      number: 1,
      title: 'Browse and Book',
      description: 'Search for trainers by location, specialty, or availability. Check their profiles, certifications, and reviews.',
      detail: 'Book a session that fits your schedule and make a secure payment—all in one place.',
      bonus: '✨ No credit card required to browse',
    },
    {
      number: 2,
      title: 'Have a Great Workout',
      description: 'Meet your trainer at their verified facility, a local gym, or train virtually from home.',
      detail: 'Get personalized attention, proper form guidance, and a workout tailored to your goals.',
      bonus: '🏋️ Equipment provided or work with what you have',
    },
    {
      number: 3,
      title: 'Review and Rebook',
      description: 'Share your experience by leaving a review. Help others discover great trainers.',
      detail: 'Loved your session? Rebook with your favorite trainer and build lasting fitness results.',
      bonus: '💯 Build your fitness journey one session at a time',
    },
  ];

  const displaySteps = steps || defaultSteps;

  return (
    <section className={css.root}>
      <div className={css.container}>
        <h2 className={css.title}>
          {title || <FormattedMessage id="SectionHowItWorks.title" defaultMessage="How GymNet Works" />}
        </h2>
        {subtitle && <p className={css.subtitle}>{subtitle}</p>}

        <div className={css.stepsContainer}>
          {displaySteps.map((step, index) => (
            <div key={index} className={css.step}>
              <div className={css.stepNumber}>{step.number}</div>
              <h3 className={css.stepTitle}>{step.title}</h3>
              <p className={css.stepDescription}>{step.description}</p>
              {step.detail && <p className={css.stepDetail}>{step.detail}</p>}
              {step.bonus && <p className={css.stepBonus}>{step.bonus}</p>}
            </div>
          ))}
        </div>

        <div className={css.videoWrap}>
          <p className={css.videoLabel}>See it in action</p>
          <div className={css.videoContainer}>
            <iframe
              className={css.videoFrame}
              src="https://www.youtube-nocookie.com/embed/Cj-dq9NokhY"
              title="How GymNet Works"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </div>
      </div>
    </section>
  );
};

SectionHowItWorks.defaultProps = {
  title: null,
  subtitle: 'Get started in 3 simple steps',
  steps: null,
};

SectionHowItWorks.propTypes = {
  title: string,
  subtitle: string,
  steps: arrayOf(
    shape({
      number: string,
      title: string.isRequired,
      description: string.isRequired,
      detail: string,
      bonus: string,
    })
  ),
};

export default SectionHowItWorks;